import React from 'react';
import PropTypes from 'prop-types';
import FormOption from './FormOption';
import Pricing from '../pricing/Pricing';

const FormOptions = ({
    t, options, handleChangeRadio, error, radioButton
}) => (
    <div className="estimation-form-options">
        {options.map((option, index) => (
            <FormOption
              key={ index }
              option={ option }
              t={ t }
              error={ error }
              handleChangeRadio={ handleChangeRadio }
              radioButton={ radioButton }
              total={ options.length }
            />
        ))}
        <div className="pricing-scroll">
            <div id="pricing-scroll"/>
            {radioButton &&
                <Pricing
                  currentPricing={ options.find((option) => option.key === radioButton) }
                />}
        </div>
    </div>
);

FormOptions.propTypes = {
    t: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        translations: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            brochure_cta_text: PropTypes.string
        }),
        brochure: PropTypes.shape(),
        icon: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            translations: PropTypes.shape({
                brochure: PropTypes.string,
                brochure_cta_text: PropTypes.string,
                button_cta_text: PropTypes.string,
                duration: PropTypes.string,
                price: PropTypes.string,
                subtitle: PropTypes.string,
                title: PropTypes.string
            }),
            features: PropTypes.arrayOf(PropTypes.shape({
                translations: PropTypes.shape({
                    name: PropTypes.string.isRequired
                })
            }))
        }))
    })).isRequired,
    handleChangeRadio: PropTypes.func.isRequired,
    error: PropTypes.shape().isRequired,
    radioButton: PropTypes.string.isRequired
};

export default FormOptions;



// WEBPACK FOOTER //
// ./src/components/content/estimation/form/FormOptions.jsx